export const DEMO_ACCOUNT_TYPE = 'demo';

export const DEMO_LANDING_PATH = '/user-feed';

export const GUEST_STRIP_DISMISSED_KEY = 'demo-strip-dismissed';

export const DEMO_NOTICE_DISMISSED_KEY = 'demo-notice-dismissed';

export const DEMO_STRIP_COPY = Object.freeze({
	GUEST: 'Explore the app without signing up',
	GUEST_MOBILE: 'Explore without signing up',
	TRY_DEMO_LABEL: 'Try the demo',
	TRY_DEMO_BUSY_LABEL: 'Starting...',
	NOTICE_LEAD: "You're using a demo account.",
	NOTICE_REST: 'It and everything you post will be deleted within 24 hours.',
	NOTICE_LEAD_MOBILE: 'Demo account',
	NOTICE_REST_MOBILE: '· deleted within 24 hours',
	CLOSE_LABEL: 'Close',
});
